import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api from "../lib/api";

const AdminForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Backend never leaks — still show generic on error boundary.
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111111] text-white flex items-center justify-center px-6" data-testid="admin-forgot-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-block bg-white/5 p-4 rounded-sm">
            <Logo className="h-14 w-14" showWordmark invert />
          </div>
          <div className="mt-6 overline text-[#7A1519]">Admin Portal</div>
          <h1 className="mt-2 font-display text-3xl tracking-tight font-semibold">Reset your password</h1>
          <p className="mt-3 text-sm text-white/60">Enter the email tied to your admin account. If it exists, we'll send a secure reset link.</p>
        </div>

        {sent ? (
          <div className="bg-white/5 border border-white/10 p-8 rounded-sm text-center" data-testid="admin-forgot-sent">
            <div className="text-sm text-white/80">
              If that email is registered, a reset link has been sent. Check your inbox (and spam).
              The link expires in 1 hour.
            </div>
            <Link to="/admin/login" className="inline-block mt-6 text-xs text-white/60 hover:text-white underline underline-offset-4">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white/5 border border-white/10 p-8 rounded-sm space-y-5">
            <div>
              <label className="overline text-white/50 block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-black/40 border border-white/10 px-4 py-3 rounded-sm text-sm outline-none focus:ring-1 focus:ring-[#7A1519]"
                data-testid="admin-forgot-email"
                autoComplete="username"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="w-full bg-[#7A1519] hover:bg-[#5a0f12] text-white py-3.5 rounded-sm text-sm font-semibold tracking-wide disabled:opacity-50"
              data-testid="admin-forgot-submit"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-center pt-2">
              <Link to="/admin/login" className="text-xs text-white/60 hover:text-white underline underline-offset-4">
                Back to sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminForgotPassword;
